var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinAround(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#212121;stroke:#212121;}.a{opacity:0;}.b{stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.55 1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.451,29.8c-1.429,0-4.131-.275-4.131-1.318s2.7-1.313,4.131-1.313,4.132.274,4.132,1.313S8.88,29.8,7.451,29.8Zm0-6.279a.323.323,0,0,1-.289-.177L.732,10.971A8.7,8.7,0,0,1,0,7.471a7.45,7.45,0,1,1,14.9,0,8.53,8.53,0,0,1-.811,3.663L7.741,23.343A.326.326,0,0,1,7.455,23.52Zm0-20.954A4.908,4.908,0,1,0,12.34,7.471,4.905,4.905,0,0,0,7.455,2.566Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAround);
export default __webpack_public_path__ + "static/media/Pin_around.9263a58661b2152fe51303cbd1f8f4c8.svg";
export { ForwardRef as ReactComponent };